import { render } from "./RangeField.vue?vue&type=template&id=b5462e64"
import script from "./RangeField.vue?vue&type=script&lang=js"
export * from "./RangeField.vue?vue&type=script&lang=js"

import "./RangeField.vue?vue&type=style&index=0&id=b5462e64&lang=css"
script.render = render

export default script